import { Component } from "@angular/core";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { AuthService } from "../auth/service/auth.service";

@Component({
  selector: "app-access-paused",
  templateUrl: "./access-paused.component.html",
  styleUrl: "./access-paused.component.scss",
  standalone: false,
})
export class AccessPausedComponent {
  isLoading = false;
  public currentLang = "en";

  constructor(
    public translate: TranslateService,
    private authService: AuthService
  ) {}

  onLogout(): void {
    this.authService.logout();
  }
}
